{
  "ungroupedMappingWorkNo": "AAK",
  "fortnoxIntegrationAddress": "https://apps.fortnox.se/oauth-v1/auth",
  "fortnoxClientId": "SHQHJuVM27Xf",
  "agGridKey": "Using_this_{AG_Grid}_Enterprise_key_{AG-080986}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Sysarb}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Sysarb}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Sysarb}_need_to_be_licensed___{Sysarb}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{26_September_2026}____[v3]_[01]_MTc5MDM3NzIwMDAwMA==52647a9b6dc314f9ca01d04c2850f8f8",
  "intercomAppId": "uwqnwidk",
  "intercomKey": "jGt7fBP50pi4gSEX8ygIqYp8t7AEvlYxNpOcug81",
  "analyticsKey": "GTM-TNPK62F",
  "cookiebotId": "ec7e858a-7699-4e2a-924a-83bebde18a03",
  "enableTranslations": false,
  "enableGtm": false,
  "enableVersionCheck": false,
  "planhatTenantId": "",
  "enablePlanhat": false,
  "satismeterKey": "",
  "enableSatismeter": false,
  "enableOpentelemetry": true,
  "enableUmami": true,
  "umamiScriptUrl": "https://ummy.sysarb.dev/script.js",
  "umamiWebsiteId": "d3d99a07-6188-407e-b628-45a94035d4fd"
}
